import axios from "axios";
import Swal from "sweetalert2";

export const getToken = async () => {
  const url = process.env.REACT_APP_API_BASEURL;
  const tokenUser = process.env.REACT_APP_CLIENT_USER;
  const tokenPwd = process.env.REACT_APP_CLIENT_PWD;

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: `${url}/login`,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Basic ${btoa(`${tokenUser}:${tokenPwd}`)}`,
    },
  };

  try {
    const response = await axios.request(config);
    const token = response.data.authorisation.token;

    sessionStorage.setItem("token_app", token);
    return token;
  } catch (error: any) {
    const errorMessage =
      error.response.data?.message ||
      error.response.data?.errors?.error ||
      "Tente novamente";
    Swal.fire({
      title: "Erro!",
      text: errorMessage,
      icon: "error",
      confirmButtonText: "OK",
      confirmButtonColor: "#355B94",
    });
  }
};
